<template>
    <div class="image-block image-block--storybook" :class="props.orientation">
        <figure>
            <div class="container">
                <div class="row">
                    <div class="col-md-8 col-xl-9">
                        <div class="image-block__image" :style="{
                                'background-image':
                                    props.orientation === ImageBlockOrientation.fullbleed
                                        ? 'url(' + props.image + ')'
                                        : null
                            }">
                            <img :src="props.image" :alt="props.alt" @load="onImageLoad" loading="lazy" />
                        </div>
                    </div>
                    <div class="col-md-4 col-xl-3">
                        <div class="image-block__text" v-if="props.text || props.credits">
                            <div class="container">
                                <figcaption>
                                    <span v-html="props.text"></span>
                                    <span v-if="props.credits">
                                        {{props.credits}}
                                    </span>
                                </figcaption>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </figure>
    </div>
</template>

<script setup>
    const props = defineProps({
        image: {
            type: String,
            required: true
        },
        alt: String,
        text: String,
        credits: String,
        orientation: {
            type: String,
            validator: function (value) {
                return Object.values(ImageBlockOrientation).indexOf(value) !== -1;
            },
            default: ImageBlockOrientation.center
        }
    });

    const emit = defineEmits(['on-image-loaded']);

    const onImageLoad = (e) => {
        emit('on-image-loaded', e);
    };
</script>

<script>
    export const ImageBlockOrientation = {
        center: 'image-block--center',
        fullbleed: 'image-block--fullbleed',
        left: 'image-block--left',
        right: 'image-block--right'
    };
</script>
